import React, { Component } from 'react'
import Main from './../../components/main'
import { Divider, Card } from 'antd'

class Dashboard extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    return (
      <Main>
        <div>
          <h1>Dashboard</h1>
          <Card>
            <p>Nomor Rekening BCA Transfer :</p>
            <h3>0083595091</h3>
            <Divider />
            <p>Nomor rekening BNI Transfer :</p>
            <h3>1704274443</h3>
            <Divider />
            <p>Nomor rekening BRI Transfer :</p>
            <h3>000501003219303</h3>
            <Divider />
            <p>Nomor rekening Mandiri Transfer :</p>
            <h3>1300017483366</h3>
          </Card>
        </div>
      </Main>
    )
  }
}

export default Dashboard



// WEBPACK FOOTER //
// src/pages/dashboard/index.js